export const getVersion = () => 'v3.0.26';
